import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ActivityLogTable } from "@/components/activity/ActivityLogTable";
import { useTranslation } from "react-i18next";

type ActivityLogTabsProps = {
  storeId: string | null;
};

export function ActivityLogTabs({ storeId }: ActivityLogTabsProps) {
  const { t } = useTranslation();

  return (
    <Tabs defaultValue="all" className="w-full">
      <TabsList className="grid grid-cols-7 md:w-fit">
        <TabsTrigger value="all">{t("all")}</TabsTrigger>
        <TabsTrigger value="order">{t("order")}</TabsTrigger>
        <TabsTrigger value="menu_item">{t("menu")}</TabsTrigger>
        <TabsTrigger value="table">{t("tables")}</TabsTrigger>
        <TabsTrigger value="store">{t("stores.title")}</TabsTrigger>
        <TabsTrigger value="employee">{t("staff")}</TabsTrigger>
        <TabsTrigger value="user">{t("users")}</TabsTrigger>
      </TabsList>

      <TabsContent value="all" className="mt-4">
        <ActivityLogTable storeId={storeId} entityType={null} />
      </TabsContent>

      <TabsContent value="order" className="mt-4">
        <ActivityLogTable storeId={storeId} entityType="order" />
      </TabsContent>

      <TabsContent value="menu_item" className="mt-4">
        <ActivityLogTable storeId={storeId} entityType="menu_item" />
      </TabsContent>

      <TabsContent value="table" className="mt-4">
        <ActivityLogTable storeId={storeId} entityType="table" />
      </TabsContent>

      <TabsContent value="store" className="mt-4">
        <ActivityLogTable storeId={storeId} entityType="store" />
      </TabsContent>

      <TabsContent value="employee" className="mt-4">
        <ActivityLogTable storeId={storeId} entityType="employee" />
      </TabsContent>

      <TabsContent value="user" className="mt-4">
        <ActivityLogTable storeId={storeId} entityType="user" />
      </TabsContent>
    </Tabs>
  );
}
